const events = {
  deleteUser: "deleteUser",
  userUpdated: "userUpdated",
};
export default events;
